import React from "react";

import ContentPreview from "../ContentPreview";

import { moveContent } from "../../../apis/firebase";
import FilterList from "../../utils/FilterList";
import AddText, { manageText } from "./AddText";
import AddFile from "./AddFile";

export default function CampaignContent({ post }: { post: Post }) {
  const numOfPosts = post.content?.length || 0;

  return (
    <>
      <div className="tac mt2 mb2">
        <AddText post={post} />
        <AddFile post={post} />
      </div>
      <ul>
        <FilterList
          items={post.content ? post.content.slice().reverse() : []}
          fields={["meta.name", "value"]}
        >
          {(items) =>
            items.map((c, i) => {
              const onUp =
                numOfPosts > 1 && i > 0
                  ? () => moveContent(post.id, c.id as string, "up")
                  : undefined;
              const onDown =
                numOfPosts > 1 && i < numOfPosts - 1
                  ? () => moveContent(post.id, c.id as string, "down")
                  : undefined;
              return (
                <ContentPreview
                  key={c.id || c.type}
                  content={c}
                  post={post}
                  onEdit={() => manageText(post, c)}
                  onDelete={() => {}}
                  onUp={onUp}
                  onDown={onDown}
                  enhancements
                />
              );
            })
          }
        </FilterList>
      </ul>
    </>
  );
}
